// This file was automatically generated from appchart.letters.relatedAttachmentsPrompt.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.letters.relatedAttachmentsPrompt');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.letters.attachments');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.relatedAttachmentsPrompt.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="related-attachments-container" class="el8DialogContainer"><p class="el8AlignCenter mb10 el8ItalicText">The item you selected references the following document(s):</p><ol class="el8AttachmentResults mb2em">');
  if (opt_data.documentSoyMaps && opt_data.documentSoyMaps.length) {
    var aList3488 = opt_data.documentSoyMaps;
    var aListLen3488 = aList3488.length;
    for (var aIndex3488 = 0; aIndex3488 < aListLen3488; aIndex3488++) {
      var aData3488 = aList3488[aIndex3488];
      output.append('<li class="el8FieldSectionOverflow">');
      el8.template.ptdata.letters.attachments.clientGeneratedAttachmentSummary(aData3488, output);
      output.append('</li>');
    }
  }
  if (opt_data.attachmentSoyMaps && opt_data.attachmentSoyMaps.length) {
    var aList3495 = opt_data.attachmentSoyMaps;
    var aListLen3495 = aList3495.length;
    for (var aIndex3495 = 0; aIndex3495 < aListLen3495; aIndex3495++) {
      var aData3495 = aList3495[aIndex3495];
      output.append('<li class="el8FieldSectionOverflow">');
      el8.template.ptdata.letters.attachments.savedAttachmentSummary(aData3495, output);
      output.append('</li>');
    }
  }
  output.append('</ol><p class="el8AlignCenter el8Bold mb20">Would you like to include the above document(s) in your attachments?</p></div>');
  if (!opt_sb) return output.toString();
};
